<h1 mat-dialog-title>{{TitleText}}</h1>
<div mat-dialog-content>
    <form>
        <p [innerHtml]="MessageText"></p>
        <mat-form-field style="width:100%">
            <input matInput #inputField type="text" id="idialogTextbox" [(ngModel)]="InputText" name="InputText"
                [maxlength]="MaxLength" aria-label="Text response input box" placeholder="{{InputLabel}}" />
            <mat-hint align="end" *ngIf="MaxLength">{{inputField.value.length}} / {{MaxLength}}</mat-hint>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="CancelHandler()">{{CancelText}}</button>
    <button mat-raised-button color="primary" (click)="OKHandler()"
        [disabled]="(!InputText && AllowBlankResponse !== true)">{{OKText}}</button>
</div>